import grid from './grid'

export const SCROLL_OFFSET_DEFAULT = 0

export default {
  mixins: [grid],
  data () {
    return {
      scrollOffset: SCROLL_OFFSET_DEFAULT
    }
  },
  computed: {
    /**
     * Возможна ли прокрутка влево.
     *
     * @returns {boolean}
     */
    canScrollLeft () {
      return this.scrollOffset > 0
    },
    visibleScrollableColsCount () {
      if (this.gridLg) {
        return 6
      }

      if (this.gridMd) {
        return 4
      }

      return 1
    }
  },
  methods: {
    /**
     * Возможна ли прокрутка.
     *
     * @param {Number} totalCount
     * @returns {boolean}
     */
    canScroll (totalCount) {
      return totalCount > this.visibleScrollableColsCount
    },
    /**
     * Возможна ли прокрутка вправо.
     *
     * @param {Number} totalCount
     * @returns {boolean}
     */
    canScrollRight (totalCount) {
      return totalCount > this.scrollOffset + this.visibleScrollableColsCount
    },
    /**
     * Возвращает сдвинутые данные.
     *
     * @param {Array} data
     * @returns {*}
     */
    slice (data) {
      return data.slice(this.scrollOffset, this.scrollOffset + this.visibleScrollableColsCount)
    },
    /**
     * Сдвигает данные влево.
     */
    offsetLeft () {
      this.scrollOffset = this.canScrollLeft ? this.scrollOffset - 1 : this.scrollOffset
    },
    /**
     * Сдвигает данные вправо.
     */
    offsetRight (totalCount) {
      this.scrollOffset = this.canScrollRight(totalCount) ? this.scrollOffset + 1 : this.scrollOffset
    },
    /**
     * Сбрасывает сдвиг данных.
     */
    resetScrollOffset () {
      this.scrollOffset = SCROLL_OFFSET_DEFAULT
    }
  }
}
